<template>
<div>
    <Login v-if="!$root.user.isLoggedIn" />
    <div v-if="$root.user.isLoggedIn">
        <Header />
        <div class="stats">

            <div class="stats-top">
                <vm-card list>
                    <vm-row>
                        <vm-group c6>
                            <vm-button :text="'Last inn frakttabell'" :working="loading" @clicked="fetchData" />
                        </vm-group>
                        <vm-group c6>
                            <vm-button :text="'Envelopes'" :working="loading" @clicked="queryEnvelopes" />
                        </vm-group>
                    </vm-row>
                </vm-card>

            </div>

            <div class="stats-main">

                <vm-card v-if="statsLoaded">
                    <vm-row>
                        <vm-group c4>
                            <vm-label :text="'Antall kunder i frakt-tabell'" />
                            <vm-input v-model="countCustomers" maxbo disabled />
                        </vm-group>
                        <vm-group c4>
                            <vm-label :text="'Kunder med duplikater'" />
                            <vm-input v-model="countAffected" maxbo disabled />
                        </vm-group>
                        <vm-group c4>
                            <vm-label :text="'Duplikate rader totalt'" />
                            <vm-input v-model="countDuplicates" maxbo disabled />
                        </vm-group>
                    </vm-row>
                </vm-card>
            </div>

        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import axios from 'axios';
import log from '../log';
import shippingapi from '../shippingapi';
import verified from '../verified';

import Header from '../components/nav/Header'
import Login from '../components/login/Login'

export default {
name: 'Stats',
components: {
    Header,
    Login
},
data() {
    return {
        loading: false,
        statsLoaded: false,
        countCustomers: 0,
        countAffected: 0,
        countDuplicates: 0,

        envelopes: []
    }
},
methods: {

    async fetchData() {
        this.loading = true;
        const rows = await shippingapi.getAllRows();
        this.loading = false;
        console.log('rows', rows);
        this.processData(rows);
    },

    async queryEnvelopes() {

        this.envelopes = await verified.queryEnvelopes();

        for (const i in this.envelopes) {

            const envelope = await verified.getFullEnvelope(this.envelopes[i].id);
            console.log('envelope', envelope);
            if (envelope.userdata) {

                if (envelope.userdata.customer) {
                    const envelopeShipping = this.getShippingFromShipping(envelope.userdata.shipping);
                    console.log('envelopeShipping', envelopeShipping);
                    /* const envelopeItems = envelope.userdata.shdata;
                    this.sortItems(envelopeItems);
                    console.log('envelopeItems', envelopeItems); */

                    const tableShipping = await shippingapi.getShippingAndRows(envelope.userdata.customer.number);
                    console.log('tableShipping', tableShipping);

                    const isIdentical = this.isShippingIdentical(envelopeShipping, tableShipping.shipping);
                    console.log('isIdentical', isIdentical);
                    if (!isIdentical) {
                        console.log('envelopeId=' + envelope.id + ' number=' + envelope.userdata.customer.number + ' name=' + envelope.userdata.customer.name);
                    }
                }else {
                    const envelopeShipping = this.getShippingFromShipping(envelope.userdata.shipping);
                    console.log('envelopeShipping', envelopeShipping);
                    /* const envelopeItems = envelope.userdata.shdata;
                    this.sortItems(envelopeItems);
                    console.log('envelopeItems', envelopeItems); */

                    const tableShipping = await shippingapi.getShippingAndRows(envelope.userdata.company.customer_number);
                    console.log('tableShipping', tableShipping);

                    const isIdentical = this.isShippingIdentical(envelopeShipping, tableShipping.shipping);
                    console.log('isIdentical', isIdentical);
                    if (!isIdentical) {
                        console.log('envelopeId=' + envelope.id + ' number=' + envelope.userdata.company.customer_number + ' name=' + envelope.userdata.company.name);
                    }
                }

                
            }

        }

    },

    isShippingIdentical(shipping1, shipping2) {
        let identical = true;
        if (!(shipping1.days7.discount == shipping2.days7.discount && shipping1.days7.threshold == shipping2.days7.threshold)) {
            if (shipping1.days7.discount != 0) {
                console.log('days7 mismatch');
                identical = false;
            }
        } 
        if (!(shipping1.days3.discount == shipping2.days3.discount && shipping1.days3.threshold == shipping2.days3.threshold)) {
            if (shipping1.days3.discount != 0) {
                console.log('days3 mismatch');
                identical = false;
            }
        }
        if (!(shipping1.low.discount == shipping2.low.discount && shipping1.low.threshold == shipping2.low.threshold)) {
            if (shipping1.low.discount != 0) {
                console.log('low mismatch');
                identical = false;
            }
        } 
/*         if (!(shipping1.med.discount == shipping2.med.discount && shipping1.med.threshold == shipping2.med.threshold)) {
            console.log('med mismatch');
            identical = false;
        }  */
        if (!(shipping1.high.discount == shipping2.high.discount && shipping1.high.threshold == shipping2.high.threshold)) {
            if (shipping1.high.discount != 0) {
                console.log('high mismatch');
                identical = false;
            }
        } 
        if (!(shipping1.precision.discount == shipping2.precision.discount && shipping1.precision.threshold == shipping2.precision.threshold)) {
            if (shipping1.precision.discount != 0) {
                console.log('precision mismatch');
                identical = false;
            }
        } 
        if (!(shipping1.express.discount == shipping2.express.discount && shipping1.express.threshold == shipping2.express.threshold)) {
            if (shipping1.express.discount != 0) {
                console.log('express mismatch');
                identical = false;
            }
        } 
        if (!(shipping1.crane.discount == shipping2.crane.discount && shipping1.crane.threshold == shipping2.crane.threshold)) {
            if (shipping1.crane.discount != 0) {
                console.log('crane mismatch');
                identical = false;
            }
        }
        return identical;
    },
    getShippingFromShipping(shipping) {
        console.log('shipping', shipping);
        const envelopeShipping = {
            days7: { discount: '', threshold: '', name: 'days7' },
            days3: { discount: '', threshold: '', name: 'days3' },
            low: { discount: '', threshold: '', name: 'low' },
            med: { discount: '', threshold: '', name: 'med' },
            high: { discount: '', threshold: '', name: 'high' },
            precision: { discount: '', threshold: '', name: 'precision' },
            express: { discount: '', threshold: '', name: 'express' },
            crane: { discount: '', threshold: '', name: 'crane' }
        };
        this.getSingleShippingFromShipping(envelopeShipping.days7, shipping.days7);
        this.getSingleShippingFromShipping(envelopeShipping.days3, shipping.days3);
        this.getSingleShippingFromShipping(envelopeShipping.low, shipping.low);
        this.getSingleShippingFromShipping(envelopeShipping.med, shipping.med);
        this.getSingleShippingFromShipping(envelopeShipping.high, shipping.high);
        this.getSingleShippingFromShipping(envelopeShipping.precision, shipping.precision);
        this.getSingleShippingFromShipping(envelopeShipping.express, shipping.express);
        this.getSingleShippingFromShipping(envelopeShipping.crane, shipping.crane);
        return envelopeShipping;
    },
    getSingleShippingFromShipping(to, from) {
        to.discount = from.discount.toString().replace(' %', '');
        to.threshold = from.threshold.replace(' kr', '').replace(' ', '');
    },
    sortItems(items) {
        for (let i in items) {
            items[i].sort = Number(items[i].ArticleId);
        }
        items.sort((a, b) => (a.sort > b.sort) ? 1 : -1);
    },

    processData(data) {
        let customers = [];
        let duplicates = [];
        let affectedCount = 0;

        for (let i in data) {
            let match = false;
            for (let j in customers) {
                if (customers[j].CustomerId == data[i].CustomerId) {
                    customers[j].entries.push(data[i]);
                    match = true;
                    break;
                }
            }
            if (!match) {
                customers.push({
                    CustomerId: data[i].CustomerId,
                    entries: []
                });
            }
        }


        for (let i in customers) {
            let dayCount = 0;
            let affected = false;
            for (let j in customers[i].entries) {
                if (customers[i].entries[j].ArticleId == '2000101') {
                    dayCount += 1;
                }
            }
            let list = [];
            for (let j in customers[i].entries) {
                let match = false;
                for (let k in list) {
                    if (customers[i].entries[j].ArticleId == '2000101') {
                        if (dayCount > 3) {
                            if (customers[i].entries[j].ArticleId == list[k].ArticleId
                            && customers[i].entries[j].DiscountPercentage == list[k].DiscountPercentage
                            && customers[i].entries[j].Threshold == list[k].Threshold) {
                                match = true;
                                affected = true;
                            }
                        }
                    }else {
                        if (customers[i].entries[j].ArticleId == list[k].ArticleId) {
                            match = true;
                            affected = true;
                        }
                    }
                }
                if (match) {
                    duplicates.push(customers[i].entries[j]);
                }else {
                    list.push(customers[i].entries[j]);
                }
            }
            if (affected) {
                affectedCount += 1;
                console.log('duplicate cid = ' + customers[i].CustomerId)
            } 
        }

        console.log("customers", customers);
        console.log("duplicates", duplicates);
        console.log("affected customers = " + affectedCount);

        this.countCustomers = customers.length;
        this.countAffected = duplicates.length;
        this.countDuplicates = affectedCount;
        this.statsLoaded = true;
    },
    async loadEnvelopes() {
        this.loading = true;

        const customers = [];

        for (let i = 1; i < 12; i++) {
            let number = i;
            if (Number(i) < 10) number = '0' + i;
            const file = 'envelopes/d' + number + '.json';
            let response = await axios.get(file);
            for (let j in response.data) {
                const customer = {
                    envelopeId: response.data[j].id,
                    name: this.parseName(response.data[j].documents[0].name),
                    dateC: new Date(response.data[j].publishDate),
                    dateU: new Date(response.data[j].modified),
                }
                let match = false;
                for (let c in customers) {
                    if (customers[c].name == customer.name) {
                        match = true;
                        if (customer.dateU > customers[c].dateU) {
                            customers[c].envelopeId = customer.envelopeId;
                            customers[c].dateU = customer.dateU;
                            customers[c].dateC = customer.dateC;
                        }
                    }
                }
                if (!match) {
                    customers.push(customer);
                }
            }
        }

        for (let i = 1; i < 51; i++) {
            let number = i;
            if (Number(i) < 10) number = '0' + i;
            const file = 'envelopes/g' + number + '.json';
            let response = await axios.get(file);
            for (let j in response.data) {
                const customer = {
                    envelopeId: response.data[j].id,
                    name: this.parseName(response.data[j].documents[0].name),
                    dateC: new Date(response.data[j].publishDate),
                    dateU: new Date(response.data[j].modified),
                }
                let match = false;
                for (let c in customers) {
                    if (customers[c].name == customer.name) {
                        match = true;
                        if (customer.dateU > customers[c].dateU) {
                            customers[c].envelopeId = customer.envelopeId;
                            customers[c].dateU = customer.dateU;
                            customers[c].dateC = customer.dateC;
                        }
                    }
                }
                if (!match) {
                    customers.push(customer);
                }
            }
        }

        for (let i in customers) {
            customers[i].index = (Number(i) + 1);
        }

        console.log(JSON.stringify(customers));
        this.loading = false;
    },
    parseName(name) {
        let str = name;
        if (str == undefined) str = 'undefined';
        if (str.includes('_')) str = str.split('_').join(' ');
        str = str.replace('Fraktavtale ', '');
        str = str.replace('.pdf', '');
        return str;
    }
},
async created() {
    
}
}
</script>
<style scoped>

.stats {
    width: 100%;
    margin-top: 40px;
}

.stats-top {
    max-width: 400px;
    margin: 0 auto;
}

.stats-main {
    max-width: 800px;
    margin: 0 auto;
}

</style>